@if (!limitedSizes) {
  <nz-form-item [formGroup]="formGroup">
    <nz-form-label nzRequired nzFor="departmentId">Struktūrvienība</nz-form-label>
    <nz-form-control clValidationError="departmentId">
      <nz-select nzShowSearch nzPlaceHolder="Struktūrvienība" (ngModelChange)="departmentChanged($event)" formControlName="departmentId">
        @for (group of departmentGroups; track $index) {
          <nz-option-group [nzLabel]="group.groupName">
            @for (d of group.departments; track d.id) {
              <nz-option [nzLabel]="d.name" [nzValue]="d.id"></nz-option>
            }
          </nz-option-group>
        }
      </nz-select>
    </nz-form-control>
  </nz-form-item>
}

@if (limitedSizes) {
  <nz-form-item [formGroup]="formGroup">
    <nz-form-label nzRequired [nzSm]="8" [nzXs]="24" nzFor="departmentId">Struktūrvienība</nz-form-label>
    <nz-form-control [nzSm]="16" [nzXs]="24" clValidationError="departmentId">
      <nz-select nzShowSearch nzPlaceHolder="Struktūrvienība" (ngModelChange)="departmentChanged($event)" formControlName="departmentId">
        @for (group of departmentGroups; track $index) {
          <nz-option-group [nzLabel]="group.groupName">
            @for (d of group.departments; track d.id) {
              <nz-option [nzLabel]="d.name" [nzValue]="d.id"></nz-option>
            }
          </nz-option-group>
        }
      </nz-select>
    </nz-form-control>
  </nz-form-item>
}
